import Vue from 'vue'
import {
  Button,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Pagination,
  Menu,
  MenuItem,
  Submenu,
  Container,
  Header,
  Aside,
  Main,
  Col,
  Row,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Card,
  Loading,
  MessageBox,
  Message,
  Dialog,
  Icon,
  Cascader,
  Upload,
  Radio,
  RadioGroup,
  Tag,
  Tree,
  DatePicker,
  Popover,
  Image,
  Autocomplete,
  Link,
  Divider,
  Collapse,
  CollapseItem,
  Avatar,
  CheckboxGroup,
  Checkbox,
  Tooltip,
  InputNumber,
  Switch
} from 'element-ui'

Vue.use(Button)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Pagination)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Col)
Vue.use(Row)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Card)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Cascader)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Autocomplete)
Vue.use(Link)
Vue.use(Divider)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Avatar)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Tooltip)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
